import React, { useEffect, useState } from "react";

const Sidebar = () => {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  const [openMenus, setOpenMenus] = useState({});
  const [commandOpen, setCommandOpen] = useState(false);
  const [commandSearch, setCommandSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener("popstate", handleLocationChange);

    return () => {
      window.removeEventListener("popstate", handleLocationChange);
    };
  }, []);

  const normalizePath = (path) => {
    if (!path) return "/";

    // Remove trailing slash
    if (path.length > 1 && path.endsWith("/")) {
      return path.slice(0, -1);
    }

    return path;
  };

  const isActive = (path) => {
    return normalizePath(currentPath) === normalizePath(path);
  };

  const isParentActive = (paths) => {
    return paths.some((path) => isActive(path));
  };

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const handleLinkClick = (path, parentMenu = null) => {
    setCurrentPath(path);

    if (parentMenu) {
      setOpenMenus((prev) => ({
        ...prev,
        [parentMenu]: true,
      }));
    }
  };

  const NAV = [
    { label: "Dashboard", icon: "bi-grid-1x2", path: "/index" },
    { label: "All Orders", icon: "bi-bag", path: "/orders" },
    {
      label: "Create New Order",
      icon: "bi-plus-circle",
      path: "/create_order",
    },
    {
      label: "Bulk Order",
      icon: "bi-cloud-arrow-up",
      path: "/create_order?view=bulk",
    },
    {
      label: "Pickup Requests",
      icon: "bi-arrow-up-square",
      path: "/warehouse",
    },
    {
      label: "NDR",
      icon: "bi-exclamation-square",
      path: "/ndr",
    },
    {
      label: "Weight Discrepancy",
      icon: "bi-box2",
      path: "/weight_discrepancies_list",
    },
    {
      label: "Rate Card",
      icon: "bi-receipt",
      path: "/rate_card",
    },
    {
      label: "Warehouse",
      icon: "bi-buildings",
      path: "/warehouse",
    },
    {
      label: "Rate Calculator",
      icon: "bi-calculator",
      path: "/rate_calculator",
    },
    // {
    //   label: "Order Allocation",
    //   icon: "bi-diagram-3",
    //   path: "/order_allocation",
    // },
    {
      label: "AfterShip",
      icon: "bi-truck",
      path: "/aftership",
    },
    {
      label: "Shipping Charges",
      icon: "bi-cash-stack",
      path: "/billing_shipping_charges",
    },
    {
      label: "Passbook",
      icon: "bi-journal-bookmark",
      path: "/billing_passbook",
    },
    {
      label: "Shipment Reports",
      icon: "bi-bar-chart-line",
      path: "/shipment_report",
    },
    {
      label: "Invoices",
      icon: "bi-file-earmark-text",
      path: "/invoices_list",
    },
    {
      label: "Team",
      icon: "bi-people",
      path: "/team",
    },
    {
      label: "Support Tickets",
      icon: "bi-ticket",
      path: "/support_tickets",
    },
    {
      label: "Support FAQ",
      icon: "bi-question-circle",
      path: "/support_faq",
    },
    {
      label: "Channel Integration",
      icon: "bi-plug",
      path: "/channel_list",
    },
    {
      label: "Developer APIs",
      icon: "bi-code-slash",
      path: "/developer_apis",
    },
    {
      label: "Label Settings",
      icon: "bi-tag",
      path: "/master_label_settings",
    },
  ];

  const openCommandPalette = () => {
    setCommandSearch("");
    setActiveIndex(0);
    setCommandOpen(true);

    document.body.style.overflow = "hidden";
  };

  const closeCommandPalette = () => {
    setCommandOpen(false);
    setCommandSearch("");
    setActiveIndex(0);

    document.body.style.overflow = "";
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();

        if (commandOpen) {
          closeCommandPalette();
        } else {
          openCommandPalette();
        }

        return;
      }

      if (!commandOpen) return;

      if (e.key === "Escape") {
        e.preventDefault();
        closeCommandPalette();
        return;
      }

      const filtered = NAV.filter((item) => {
        const q = commandSearch.trim().toLowerCase();

        if (!q) return true;

        return (
          item.label.toLowerCase().includes(q) ||
          item.path.toLowerCase().includes(q)
        );
      });

      if (e.key === "ArrowDown") {
        e.preventDefault();

        setActiveIndex((prev) => Math.min(prev + 1, filtered.length - 1));
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();

        setActiveIndex((prev) => Math.max(prev - 1, 0));
      }

      if (e.key === "Enter") {
        e.preventDefault();

        if (filtered[activeIndex]) {
          window.location.href = filtered[activeIndex].path;
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [commandOpen, commandSearch, activeIndex]);

  return (
    <div>
      {/* Search */}
      <div
        className="s-search"
        onClick={openCommandPalette}
        style={{ cursor: "pointer" }}
      >
        <i className="bi bi-search"></i>

        <span className="s-search-text">Search anything</span>

        <span className="kbd">⌘ K</span>
      </div>
      {commandOpen && (
        <div
          className="cmd-palette-overlay show"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeCommandPalette();
            }
          }}
        >
          <div className="cmd-palette show">
            <div className="cmd-palette-input">
              <i className="bi bi-search"></i>

              <input
                type="text"
                placeholder="Search pages..."
                autoComplete="off"
                autoFocus
                value={commandSearch}
                onChange={(e) => {
                  setCommandSearch(e.target.value);
                  setActiveIndex(0);
                }}
              />

              <button
                type="button"
                className="cmd-esc"
                onClick={closeCommandPalette}
              >
                Esc
              </button>
            </div>

            <div className="cmd-palette-results">
              {(() => {
                const q = commandSearch.trim().toLowerCase();

                const filtered = q
                  ? NAV.filter(
                      (item) =>
                        item.label.toLowerCase().includes(q) ||
                        item.path.toLowerCase().includes(q)
                    )
                  : NAV;

                if (!filtered.length) {
                  return (
                    <div className="cmd-palette-empty">
                      <i className="bi bi-search"></i>
                      No results for "{commandSearch}"
                    </div>
                  );
                }

                return (
                  <div className="cmd-palette-group">
                    {filtered.map((item, index) => (
                      <div
                        key={item.path}
                        className={`cmd-palette-item ${
                          index === activeIndex ? "active" : ""
                        }`}
                        onMouseEnter={() => setActiveIndex(index)}
                        onClick={() => {
                          window.location.href = item.path;
                        }}
                      >
                        <i className={`bi ${item.icon}`}></i>

                        <span className="cmd-label">{item.label}</span>

                        <span className="cmd-path">{item.path}</span>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
      )}

      <div className="s-label">Main Navigation</div>

      {/* Dashboard */}
      <a
        href="/index"
        className={`s-item ${isActive("/index") ? "active-page" : ""}`}
        onClick={() => handleLinkClick("/index")}
      >
        <i className="bi bi-grid-1x2 s-icon"></i>
        <span className="s-item-label">Dashboard</span>
      </a>

      {/* Orders */}
      <div
        className={`s-item ${
          isParentActive(["/orders", "/create_order"]) ? "active-page" : ""
        }`}
        onClick={() => toggleMenu("orders")}
        data-menu="orders"
      >
        <i className="bi bi-bag s-icon"></i>
        <span className="s-item-label">Orders</span>
        <i
          className={`bi ${
            openMenus.orders ? "bi-chevron-up" : "bi-chevron-down"
          } s-chev`}
        ></i>
      </div>

      <div
        className={`s-sub ${
          openMenus.orders || isParentActive(["/orders", "/create_order"])
            ? "open"
            : ""
        }`}
        id="menu-orders"
      >
        <a
          href="/orders"
          className={isActive("/orders") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/orders", "orders")}
        >
          All Orders
        </a>

        <a
          href="/create_order"
          className={isActive("/create_order") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/create_order", "orders")}
        >
          Create New Order
        </a>

        <a
          href="/create_order?view=bulk"
          className={
            currentPath === "/create_order" &&
            window.location.search === "?view=bulk"
              ? "sub-active"
              : ""
          }
          onClick={() => handleLinkClick("/create_order", "orders")}
        >
          Bulk Order
        </a>
      </div>

      {/* Pickup Requests */}
      <a
        href="/pickup_request"
        className={`s-item ${isActive("/pickup_request") ? "active-page" : ""}`}
        onClick={() => handleLinkClick("/pickup_request")}
      >
        <i className="bi bi-arrow-up-square s-icon"></i>
        <span className="s-item-label">Pickup Requests</span>
      </a>

      <a
        href="/manifest_list"
        className={`s-item ${isActive("/manifest_list") ? "active-page" : ""}`}
        onClick={() => handleLinkClick("/manifest_list")}
      >
        <i className="bi bi-arrow-up-square s-icon"></i>
        <span className="s-item-label">Manifest List</span>
      </a>

      {/* NDR */}
      <a
        href="/ndr"
        className={`s-item ${isActive("/ndr") ? "active-page" : ""}`}
        onClick={() => handleLinkClick("/ndr")}
      >
        <i className="bi bi-exclamation-square s-icon"></i>
        <span className="s-item-label">NDR</span>
      </a>

      {/* Weight Discrepancy */}
      <a
        href="/weight_discrepancies_list"
        className={`s-item ${
          isActive("/weight_discrepancies_list") ? "active-page" : ""
        }`}
        onClick={() => handleLinkClick("/weight_discrepancies_list")}
      >
        <i className="bi bi-box2 s-icon"></i>
        <span className="s-item-label">Weight Discrepancy</span>
      </a>

      {/* Rate Card */}
      <a
        href="/rate_card"
        className={`s-item ${isActive("/rate_card") ? "active-page" : ""}`}
        onClick={() => handleLinkClick("/rate_card")}
      >
        <i className="bi bi-receipt s-icon"></i>
        <span className="s-item-label">Rate Card</span>
      </a>

      {/* Warehouse */}
      <a
        href="/warehouse"
        className={`s-item ${isActive("/warehouse") ? "active-page" : ""}`}
        onClick={() => handleLinkClick("/warehouse")}
      >
        <i className="bi bi-buildings s-icon"></i>
        <span className="s-item-label">Warehouse</span>
      </a>

      <div className="s-label">Tools &amp; Settings</div>

      {/* Tools */}
      <div
        className={`s-item ${
          isParentActive([
            "/rate_calculator",
            "/order_allocation",
            "/aftership",
            "/shipping_rules",
            "/notification_settings",
          ])
            ? "active-page"
            : ""
        }`}
        onClick={() => toggleMenu("tools")}
        data-menu="tools"
      >
        <i className="bi bi-wrench s-icon"></i>
        <span className="s-item-label">Tools</span>
        <i
          className={`bi ${
            openMenus.tools ? "bi-chevron-up" : "bi-chevron-down"
          } s-chev`}
        ></i>
      </div>

      <div
        className={`s-sub ${
          openMenus.tools ||
          isParentActive([
            "/rate_calculator",
            "/order_allocation",
            "/aftership",
            "/shipping_rules",
            "/notification_settings",
          ])
            ? "open"
            : ""
        }`}
        id="menu-tools"
      >
        <a
          href="/rate_calculator"
          className={isActive("/rate_calculator") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/rate_calculator", "tools")}
        >
          Rate Calculator
        </a>

        {/* <a
          href="/order_allocation"
          className={isActive("/order_allocation") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/order_allocation", "tools")}
        >
          Order Allocation Engine
        </a> */}

        <a
          href="/shipping_rules"
          className={isActive("/shipping_rules") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/shipping_rules", "tools")}
        >
          Shipping Rules
        </a>

        {/* <a
          href="/notification_settings"
          className={isActive("/notification_settings") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/notification_settings", "tools")}
        >
          Notification Settings
        </a> */}

        <a
          href="/aftership"
          className={isActive("/aftership") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/aftership", "tools")}
        >
          AfterShip
        </a>

        {/* <a href="#">Boxes</a> */}
      </div>

      {/* Billing */}
      <div
        className={`s-item ${
          isParentActive(["/billing_shipping_charges", "/billing_passbook"])
            ? "active-page"
            : ""
        }`}
        onClick={() => toggleMenu("billing")}
        data-menu="billing"
      >
        <i className="bi bi-wallet s-icon"></i>
        <span className="s-item-label">Billing</span>
        <i
          className={`bi ${
            openMenus.billing ? "bi-chevron-up" : "bi-chevron-down"
          } s-chev`}
        ></i>
      </div>

      <div
        className={`s-sub ${
          openMenus.billing ||
          isParentActive(["/billing_shipping_charges", "/billing_passbook"])
            ? "open"
            : ""
        }`}
        id="menu-billing"
      >
        <a
          href="/billing_shipping_charges"
          className={isActive("/billing_shipping_charges") ? "sub-active" : ""}
          onClick={() =>
            handleLinkClick("/billing_shipping_charges", "billing")
          }
        >
          Shipping Charges
        </a>

        <a href="/billing_cod_remittance">COD Remittance</a>

        <a
          href="/billing_passbook"
          className={isActive("/billing_passbook") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/billing_passbook", "billing")}
        >
          Passbook
        </a>
        <a
          href="/billing_recharge"
          className={isActive("/billing_recharge") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/billing_recharge", "billing")}
        >
          Recharges
        </a>
      </div>

      {/* Reports */}
      <div
        className={`s-item ${
          isParentActive(["/shipment_report", "/invoices_list"])
            ? "active-page"
            : ""
        }`}
        onClick={() => toggleMenu("reports")}
        data-menu="reports"
      >
        <i className="bi bi-bar-chart-line s-icon"></i>
        <span className="s-item-label">Reports</span>
        <i
          className={`bi ${
            openMenus.reports ? "bi-chevron-up" : "bi-chevron-down"
          } s-chev`}
        ></i>
      </div>

      <div
        className={`s-sub ${
          openMenus.reports ||
          isParentActive(["/shipment_report", "/invoices_list"])
            ? "open"
            : ""
        }`}
        id="menu-reports"
      >
        <a
          href="/shipment_report"
          className={isActive("/shipment_report") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/shipment_report", "reports")}
        >
          Shipment Reports
        </a>

        <a
          href="/invoices_list"
          className={isActive("/invoices_list") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/invoices_list", "reports")}
        >
          Invoices
        </a>
      </div>

      {/* Team */}
      <a
        href="/team"
        className={`s-item ${isActive("/team") ? "active-page" : ""}`}
        onClick={() => handleLinkClick("/team")}
      >
        <i className="bi bi-people s-icon"></i>
        <span className="s-item-label">Team</span>
      </a>

      {/* Support */}
      <div
        className={`s-item ${
          isParentActive(["/support_tickets", "/support_faq"])
            ? "active-page"
            : ""
        }`}
        onClick={() => toggleMenu("support")}
        data-menu="support"
      >
        <i className="bi bi-headset s-icon"></i>
        <span className="s-item-label">Support</span>
        <i
          className={`bi ${
            openMenus.support ? "bi-chevron-up" : "bi-chevron-down"
          } s-chev`}
        ></i>
      </div>

      <div
        className={`s-sub ${
          openMenus.support ||
          isParentActive(["/support_tickets", "/support_faq"])
            ? "open"
            : ""
        }`}
        id="menu-support"
      >
        <a
          href="/support_tickets"
          className={isActive("/support_tickets") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/support_tickets", "support")}
        >
          Support Tickets
        </a>

        <a
          href="/support_faq"
          className={isActive("/support_faq") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/support_faq", "support")}
        >
          Support FAQ's
        </a>
      </div>

      {/* Integrations */}
      <div
        className={`s-item ${
          isParentActive(["/channel_list", "/developer_apis"])
            ? "active-page"
            : ""
        }`}
        onClick={() => toggleMenu("integrations")}
        data-menu="integrations"
      >
        <i className="bi bi-plug s-icon"></i>
        <span className="s-item-label">Integrations</span>
        <i
          className={`bi ${
            openMenus.integrations ? "bi-chevron-up" : "bi-chevron-down"
          } s-chev`}
        ></i>
      </div>

      <div
        className={`s-sub ${
          openMenus.integrations ||
          isParentActive(["/channel_list", "/developer_apis"])
            ? "open"
            : ""
        }`}
        id="menu-integrations"
      >
        <a
          href="/channel_list"
          className={isActive("/channel_list") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/channel_list", "integrations")}
        >
          Channel Integration
        </a>

        <a
          href="/developer_apis"
          className={isActive("/developer_apis") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/developer_apis", "integrations")}
        >
          Developer APIs (Plugin)
        </a>
      </div>

      {/* Settings */}
      <div
        className={`s-item ${
          isParentActive(["/master_label_settings"]) ? "active-page" : ""
        }`}
        onClick={() => toggleMenu("settings")}
        data-menu="settings"
      >
        <i className="bi bi-gear s-icon"></i>
        <span className="s-item-label">Settings</span>
        <i
          className={`bi ${
            openMenus.settings ? "bi-chevron-up" : "bi-chevron-down"
          } s-chev`}
        ></i>
      </div>

      <div
        className={`s-sub ${
          openMenus.settings || isParentActive(["/master_label_settings"])
            ? "open"
            : ""
        }`}
        id="menu-settings"
      >
        <a
          href="/master_label_settings"
          className={isActive("/master_label_settings") ? "sub-active" : ""}
          onClick={() => handleLinkClick("/master_label_settings", "settings")}
        >
          Label Settings
        </a>
      </div>
    </div>
  );
};

export default Sidebar;
